import * as React from 'react';
export var PricingCard = function (_a) {
    var title = _a.title, _b = _a.currency, currency = _b === void 0 ? '€' : _b, _c = _a.frequency, frequency = _c === void 0 ? 'mo' : _c, icon = _a.icon, price = _a.price, unavailable = _a.unavailable, options = _a.options, children = _a.children;
    return (React.createElement("div", { className: "card pricing-card text-center ".concat(unavailable ? 'not-available' : '') },
        React.createElement("div", { className: "image" }, typeof icon === 'string' ? React.createElement("i", { className: icon }) : icon),
        React.createElement("h5", null, title),
        React.createElement("div", { className: "price" },
            React.createElement("sup", null, currency),
            React.createElement("strong", null, price),
            React.createElement("sub", null,
                "/ ",
                frequency)),
        React.createElement("ul", { className: "options" }, options.map(function (option, i) { return (React.createElement("li", { key: i }, option)); })),
        children));
};
//# sourceMappingURL=index.js.map